export interface ColorConfig {
  color?: string;
  backgroundColor?: string;
}
